import React from 'react';
import HojaCaratula from './base/HojaCaratula';

// Etiquetas EXACTAS de la plantilla (templates/caratula/caratula_declaratoria_herederos.docx):
// el modal es una vista previa, así que lo que se lee acá tiene que coincidir renglón por
// renglón con el papel. `guardable` marca los que además de imprimirse vuelven al
// cliente/trámite (ver CaratulaDeclaratoriaDocumentoService.persistirDatosGuardables).
//
// Primera carátula de la serie con GRILLA: `herederos` es una lista de filas
// { nombre, documento, vinculo } de texto libre (no `select`) a propósito — son solo para el
// papel, prellenadas con TODOS los herederos vivos más los hijos fallecidos (su vínculo dice
// "Hijo/a (fallecido/a)"), y NO se persisten desde acá (el árbol
// completo se edita en la ficha, con TablaHerederos). El papel trae 4 filas; si hay más, el
// backend las agrega al generar (y si no entran en la hoja, van a una hoja de continuación).
const CAMPOS = {
    ingreso: { label: 'INGRESO', tipo: 'fecha' },
    referencia: { label: 'REFERENCIA', tipo: 'texto', resaltada: true },

    apellidoNombreCausante: { label: 'APELLIDO/NOMBRE CAUSANTE', tipo: 'texto' },
    dniCuitCausante: { label: 'DNI/CUIT', tipo: 'texto' },
    fechaDefuncion: { label: 'FECHA DE DEFUNCIÓN', tipo: 'texto' },

    apellidoNombreTitular: { label: 'APELLIDO/NOMBRE DEL TITULAR PRINCIPAL', tipo: 'texto' },
    dniCuilTitular: { label: 'DNI/CUIL', tipo: 'texto' },

    domicilioContacto: {
        label: 'DOMICILIO HEREDERO DE CONTACTO', tipo: 'domicilio', estructurado: 'domicilioDniDatos', guardable: true,
        nota: 'Se guarda en el domicilio DNI del cliente (el barrio que ya tenga se conserva). Vacío no borra nada.',
    },
    telefono: {
        label: 'Nº TELEFONICO', tipo: 'texto', guardable: true,
        nota: 'Trae el teléfono propio y los contactos adicionales del cliente. Solo vuelve a la ficha si dejás un único número.',
    },

    cantidadHerederos: {
        label: 'CANTIDAD DE HEREDEROS', tipo: 'texto',
        nota: 'Herederos vivos cargados en la tabla de la ficha. Editarlo acá no cambia esa tabla.',
    },
    diaSolicitudActas: { label: 'DIA QUE SE SOLICITARON LAS ACTAS', tipo: 'fecha', guardable: true },
    fotosDniHerederos: { label: 'FOTOS DEL DNI DE LOS HEREDEROS', tipo: 'sino', guardable: true },
    diaFirmaHerederos: { label: 'DIA QUE FIRMARON LOS HEREDEROS', tipo: 'fecha', guardable: true },

};

// Distribución calcada del papel: INGRESO y REFERENCIA sueltos arriba (no son cuadros), y
// adentro del recuadro cada bloque separado por una línea. Causante y titular llevan su
// documento DEBAJO, no al lado. La grilla se dibuja como tabla con los mismos encabezados que
// la plantilla; cada celda es solo el input, y se pueden agregar o quitar filas.
const SEPARADOR = { separador: true };

const TABLA_HEREDEROS = {
    grilla: {
        clave: 'herederos',
        columnas: [
            { key: 'nombre', encabezado: 'NOMBRE' },
            { key: 'documento', encabezado: 'DOCUMENTO' },
            { key: 'vinculo', encabezado: 'VINCULO' },
        ],
        filasMinimas: 4,
        etiquetaFila: 'heredero',
    },
};

const FILAS_PREVIAS = [['ingreso'], ['referencia']];
const FILAS_CUERPO = [
    { keys: ['apellidoNombreCausante', 'dniCuitCausante'], apilado: true },
    SEPARADOR,
    { keys: ['apellidoNombreTitular', 'dniCuilTitular'], apilado: true },
    SEPARADOR,
    ['fechaDefuncion'],
    SEPARADOR,
    ['domicilioContacto'],
    SEPARADOR,
    ['telefono'],
    SEPARADOR,
    ['cantidadHerederos'],
    SEPARADOR,
    TABLA_HEREDEROS,
    SEPARADOR,
    ['diaSolicitudActas'],
    SEPARADOR,
    ['fotosDniHerederos'],
    SEPARADOR,
    ['diaFirmaHerederos'],
    SEPARADOR,
];

// Una sola plantilla, sin variantes. HojaCaratula pone el resto (modal, aviso, hoja A4 y
// botones), que es igual en las demás carátulas. Sin pie: el papel no muestra
// "SACAR TURNO ANTES".
const LAYOUT = {
    tituloDoc: ['DATOS PERSONALES', 'DECLARATORIA DE HEREDEROS'],
    cabecera: [],
    filasPrevias: FILAS_PREVIAS,
    cuerpo: FILAS_CUERPO,
    pie: null,
};

/**
 * Modal de la Carátula de Declaratoria de Herederos. Muestra los renglones prellenados (lo que
 * ya está en el cliente/trámite/tabla de herederos) y en blanco lo que falta, para completar
 * antes de generar. Al confirmar, "Guardar y generar" persiste los renglones guardables y emite
 * el .docx con el DTO tal cual quedó en el formulario (WYSIWYG).
 */
export default function ModalCaratulaDeclaratoria(props) {
    return (
        <HojaCaratula
            {...props}
            titulo="Generar Carátula de Declaratoria de Herederos"
            nombreDocumento="la Carátula de Declaratoria de Herederos"
            campos={CAMPOS}
            layout={LAYOUT}
        />
    );
}
